import moment from 'moment'

export const toAbsoluteUrl = (pathname: string) => pathname

export const dateTimeFormat: (
  date?: string | undefined,
  returnFormat?: string | undefined,
  initFormat?: string
) => string | undefined = (
  date?: string,
  returnFormat?: string,
  initFormat = 'YYYY-MM-DD h:mm a'
) => {
  return date && moment(moment(date, initFormat)).format(returnFormat)
}
